
















































































































































































































import { Vue } from "vue-property-decorator";
import dayjs from "dayjs";
import moment from "moment";
import AppUploadImg from "@/components/AppUploadImg/index.vue";
import { DeviceServiceProxy } from "@/service-proxies/app-v2/workStation.service-proxies";
import {
  RepairApplyServiceProxy,
  MalfunctionTypeServiceProxy,
} from "@/service-proxies/app-v2/tpm.service-proxies";
import { EmployeeServiceProxy } from "@/service-proxies/app-v2/employee.service-proxies";
import { AuthorityDomainServiceProxy } from "@/service-proxies/app-v2/system.service-proxies";
import { CodeRuleServiceProxy } from "@/service-proxies/app-v2/code.service-proxies";
import { getLocalStorage } from "@/utils/storage";
import { getLocalLanguage } from "@/utils";

const dsp = new DeviceServiceProxy();
const rasp = new RepairApplyServiceProxy();
const esp = new EmployeeServiceProxy();
const mtsp = new MalfunctionTypeServiceProxy();
const adsp = new AuthorityDomainServiceProxy();
const csp = new CodeRuleServiceProxy();
export default Vue.extend({
  name: "AddOrEditForm",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "add",
    },
    deviceTypeId: {
      type: String,
      default: "",
    },
    editData: {
      type: Object,
    },
  },
  components: { AppUploadImg },
  data() {
    return {
      roleCodeIdList: [],
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
      show: false,
      shows: true,
      trueRepair:false,
      form: {
        deptName: "",
        urgencyName: "",
        isAffectName: "",
        applyCode: "",
        deviceCode: "",
        deviceId: undefined,
        deviceName: "",
        codeRuleId: "",
        deviceTypeId: "",
        deviceTypeName: "",
        applyUserName: "", // 申请人（当前登录用户）
        applyUserId: "",
        description: "",
        deptId: undefined,
        urgency: undefined,
        malfunctionTime: "",
        fileAddDTOList: [],
        repairUserId: undefined, // 维修负责人
        repairUserName: "",
        malfunctionId: undefined, // 故障类型id
        malfunctionCode: "",
        malfunctionName: "",
        isAffect: undefined,
      },
      fileList: [],
      deptList: [],
      deviceList: [],
      filterDeviceList: [],
      employeeList: [],
      loading: false,
      picture: "",
      deptTreeData: [],
      malfunctionList: [],
      deptParams: [], // 当前职权域id以及子层级的id集合
      defaultList: [],
    };
  },
  computed: {
    urgencyList() {
      return [
        { label: this.$t("page_tpm_repair_low"), value: 1 },
        { label: this.$t("page_tpm_repair_middle"), value: 2 },
        { label: this.$t("page_tpm_repair_high"), value: 3 },
      ];
    },
    isAffectList() {
      return [
        { label: this.$t("yes"), value: 1 },
        { label: this.$t("no"), value: 2 },
      ];
    },
    rules() {
      return {
        // 设备编码
        deviceId: [
          {
            required: true,
            message: this.$t("page_tpm_repair_select_device_code"),
            trigger: "blur",
          },
        ],
        //发生时间
        malfunctionTime: [
          {
            required: this.trueRepair,
            message: this.$t("page_tpm_repair_select_occurrence_time"),
            trigger: "change",
          },
        ],
        // 故障详情
        description: [
          {
            max: 100,
            message: this.$t("page_material_warehousing_custom_more100"),
            trigger: "change",
          },
        ],
      };
    },
  },
  watch: {
    visible: {
      handler(val) {
        if (val) {
          this.getDeviceList();
          this.getDeptList();
          this.getCodeAndRecord();
          this.getEmployeeList();

          if (this.type === "edit") {
            this.shows = false;
            // Object.assign(this.form, this.editData)
          } else {
            // 打开新建表单时重置表单项
            this.$nextTick(() => {
              this.resetForm();
            });
            // 获取系统登录的用户，作为维修申请人
            let { user_id, user_name } = getLocalStorage('USER_INFO') 
            let applyUserInfo = {
              applyUserName: user_name,
              applyUserId: user_id,
            };
            let extra = {
              applyStatus: 1, // 申请单状态： 待执行 1 执行中 2 待确认 3 已确认 4
            };
            Object.assign(this.form, applyUserInfo, extra);
          }
        }
      },
      immediate: true,
    },
    "form.deptId": {
      handler(val) {
        this.getUserByDept();
      },
      deep: true,
      immediate: true,
    },
    editData: {
      handler(val) {
        this.defaultList = [];
        if (val) {
          Object.assign(this.form, val);
          this.form.malfunctionTime = this.form.malfunctionTime
            ? moment(this.form.malfunctionTime, "YYYY-MM-DD HH:mm:ss")
            : null;
          this.defaultList = val.fileAddDTOList;
        }
      },
      deep: true,
      immediate: true,
    },
    fileList: {
      handler(val) {
        if (val) {
          let temp = val.map((item) => ({
            contentType: item.contentType,
            fileName: item.originalFilename || item.filename,
            objectKey: item.objectKey,
          }));
          this.form.fileAddDTOList = [...temp];
        }
      },
      deep: true,
    },
  },
  created() {
    csp.list("RepairApplyObject").then((res) => {
      this.roleCodeIdList = res;
    });
  },
  methods: {
    // 获取职权域列表
    async getDeptList() {
      this.deptTreeData = [];
      let res = await adsp.getEnableTreeList();
      let data = res.data[0];
      let root = {
        title: data.title,
        value: data.id,
        key: data.id,
        children: [],
      };
      root.children = this.handleTreeData(data.children);
      this.deptTreeData.push(root);
      if (this.form.deptId) {
        this.getUserByDept();
      }
    },
    handleTreeData(data) {
      data.map((item) => {
        item.value = item.id;
        item.key = item.id;
        if (item.children.length) {
          this.handleTreeData(item.children);
        }
      });
      return data;
    },
    changeRule(val) {
      this.form.codeRuleId = val;
      if (val) {
        this.form.applyCode = "";
        this.show = true;
        this.trueRepair=true
      } else {
        this.$refs.ruleForm.clearValidate("malfunctionTime");
        this.trueRepair=false
        this.show = false;
      }
    },
    changeUrgency(val) {
      if (val === 2) {
        this.form.urgencyName = "中";
      }
      if (val === 1) {
        this.form.urgencyName = "低";
      }
      if (val === 3) {
        this.urgencyName = "高";
      }
    },
    changeAffectName(val) {
      if (val === 2) {
        this.form.isAffectName = "否";
      }
      if (val === 1) {
        this.form.isAffectName = "是";
      }
    },
    changeDept(val) {
      this.parseValue(this.deptTreeData, val);
    },
    parseValue(arr, value) {
      for (let a = 0; a < arr.length; a++) {
        if (arr[a].value === value) {
          this.form.deptName = arr[a].title;
          return;
        } else if (arr[a].children.length > 0) {
          this.parseValue(arr[a].children, value);
        }
      }
    },
    getUserByDept() {
      this.deptParams = [];
      this.getDeptChild(this.deptTreeData);
      this.getEmployeeDeptList();
    },
    // 获取当前选中的职权域id以及子层级的id的集合
    getDeptChild(data) {
      const pushChildId = (sub) => {
        sub.map((item) => {
          this.deptParams.push(item.value);
          if (item.children.length) {
            pushChildId(item.children);
          }
        });
      };

      data.map((item) => {
        if (item.value === this.form.deptId) {
          this.deptParams.push(item.value);
          if (item.children.length) {
            pushChildId(item.children);
          }
        } else {
          if (item.children.length) {
            this.getDeptChild(item.children);
          }
        }
      });
    },
    // 根据职权域获取员工
    async getEmployeeDeptList() {
      if (!this.deptParams.length) {
        this.employeeList = [];
        this.getEmployeeList();
        return;
      }
      let res = await esp.employeeDeptList(this.deptParams);
      this.employeeList = res.map((item) => ({
        label: item.name,
        value: item.id,
      }));
    },
    // 获取故障类型
    async getCodeAndRecord() {
      this.malfunctionList = [];
      this.malfunctionList = await mtsp.getCodeAndRecord();
    },
    // 改变故障类型
    changeMalfunction(val) {
      let { name, code } = this.malfunctionList.find((item) => item.id === val);
      let malFunctionInfo = {
        malfunctionCode: code,
        malfunctionName: name,
      };
      Object.assign(this.form, malFunctionInfo);
    },
    // 获取设备列表
    async getDeviceList() {
      let params: any = {
        deviceTypeId: this.deviceTypeId,
        filter: "",
        tenantId: getLocalStorage("USER_INFO").tenant_id,
      };
      let list = await dsp.getPageDevices(1, params, -1);
      this.deviceList = list.records;
      this.filterDeviceList = this.deviceList.map((item) => ({
        label: item.code,
        value: item.id,
      }));
    },
    // 获取维修人员列表
    async getEmployeeList() {
      let params: any = { statusList: [1] };
      const data = await esp.getEmployeeList(params);
      this.employeeList = data.map((item) => ({
        label: item.name,
        value: item.id,
      }));
    },
    // 选择设备编码
    changeDevice(val) {
      const {
        id,
        code,
        deviceTypeId,
        deviceTypeName,
        name,
      } = this.deviceList.find((item) => item.id === val);
      let formDeviceInfo = {
        deviceId: id,
        deviceCode: code,
        deviceTypeId,
        deviceTypeName,
        deviceName: name,
      };
      Object.assign(this.form, formDeviceInfo);
    },
    // 选择维修人员
    changeRepairUser(val) {
      const { value, label } = this.employeeList.find(
        (item) => item.value === val
      );
      let repairUserInfo = {
        repairUserId: value,
        repairUserName: label,
      };
      Object.assign(this.form, repairUserInfo);
    },
    getAllData() {
      return new Promise((resolve, reject) => {
        this.$refs.ruleForm.validate((valid, data) => {
          if (valid) {
            this.form.malfunctionTime = this.form.malfunctionTime
              ? dayjs(this.form.malfunctionTime).format("YYYY-MM-DD HH:mm:ss")
              : "";
            resolve(this.form);
          } else {
            // 校验不通过
            resolve();
          }
        });
      });
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
    },
  },
});
